import { useSessionStorage } from "@sazka/utils/use-storage";
import { ref, watch } from "vue";
import { isFullAccount } from "@sazka/ng/player/player-account";

const panicButton = document.getElementById("panic-button");
if (panicButton) {
    panicButton.classList.add("panic-button--hidden");
}

const isLegalWarningClosed = ref(false);
const isRgLimitsBarClosed = ref(false);

const isLegalWarningVisible = ref(false);
const isLoyaltyStickerVisible = ref(false);
const isRgLimitsBarVisible = ref(false);
const isPanicButtonVisible = ref(false);

function showRgLimitsBar() {
    if (isRgLimitsBarClosed.value) return;
    const storage = useSessionStorage();
    const bar = storage.getJson<{
        text: string;
        showtime: number;
    }>("rg-limits-bar");
    if (bar) isRgLimitsBarVisible.value = true;
    else isPanicButtonVisible.value = true;
}

function showSticker() {
    isLoyaltyStickerVisible.value = true;
    isLegalWarningVisible.value = false;
    // 3) show rg limits bar 1 second afrer sticker
    setTimeout(showRgLimitsBar, 1000);
}

function showPanicButton() {
    isRgLimitsBarVisible.value = false;
    isPanicButtonVisible.value = true;
}

const start = () => {
    // 1) legal warning is shown when mounted
    // In case legal warning is not shown proceed to next popups
    if (!isLegalWarningVisible.value) showSticker();
};

watch(isLegalWarningClosed, (newValue) => {
    // 2) show sticker when legal warning is closed
    if (newValue) showSticker();
});

watch(isRgLimitsBarClosed, (newValue) => {
    // 4) show panic button whern rg limits bar is closed
    if (newValue) showPanicButton();
});

watch(isPanicButtonVisible, () => {
    if (panicButton) {
        if (isPanicButtonVisible.value) panicButton.classList.remove("panic-button--hidden");
        else panicButton.classList.add("panic-button--hidden");
    }
});

watch(isFullAccount, (value) => {
    isPanicButtonVisible.value = false;
    isLoyaltyStickerVisible.value = false;
    isRgLimitsBarVisible.value = false;
    isRgLimitsBarClosed.value = false;
    if (value) {
        start();
    }
});

export const usePopupsSequence = () => {
    return {
        start,
        isLegalWarningClosed,
        isLegalWarningVisible,
        isLoyaltyStickerVisible,
        isRgLimitsBarClosed,
        isRgLimitsBarVisible,
        isPanicButtonVisible,
    };
};
